import { GET, PUT, DELETE } from './api'

const table = "salesforce"

export const ReadContactPrefill = async (contactId) => {
  return await GET(`/${table}/contact-prefill/${encodeURIComponent(contactId)}`, false);
}

export const Read = async () => {
  return await GET(`/${table}`, true);
}

export const ReadOne = async (id) => {
  return await GET(`/${table}/${id}?populate=*`, true);
}

export const Update = async (params, id) => {
  return await PUT(`/${table}/${id}`, params, true);
}

export const Delete = async (id) => {
  return await DELETE(`/${table}/${id}`, true);
}
